export const mutationCallback: (
  onCollapsedToggle: (collapsed: boolean) => void,
) => (mutationsList: MutationRecord[]) => void = (onCollapsedToggle) => (mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type !== 'attributes' || mutation.attributeName !== 'collapsed') {
      return;
    }
    if (onCollapsedToggle) onCollapsedToggle(true);
  }
};
